<template>
    <s-modal
            :title="saison==null?'Créer une saison' : 'Editer une saison'"   
            :open="open"
            @save="save"
            :close="true"
            :save="saved"
            :cancel="true"
            @close="$emit('close')"
            @cancel="$emit('close')"
        >
        <div v-if="saison!=null" >
            <label class="title is-5">
                <s-l id="title_addSeason">Nom de votre saison</s-l>
            </label>
            <input type="text" class="input is-rounded is-primary" v-model="saison.nom" 
            :placeholder="'Saison '+ yearToDay"/>
            <br/><br/>
            <div v-if="saison.mode==null">
                <label class="title is-4" >Mode de classement :</label>
                <div class="buttonMode" v-on:click="setMode(0)">
                    <div class="title is-6"> Le joueur ayant le plus GRAND nombre de points gagne
                    </div>
                    <div class="explain">
                        A chaque partie joué, le joueur cumul des points
                    </div>
                </div>
                <div class="buttonMode"  v-on:click="setMode(1)">
                    <div class="title is-6"> Le joueur ayant le plus PETIT nombre de points gagne
                    </div>
                    <div class="explain">
                    A chaque concours, le joueur cumul des points par rapport à son classement
                    </div>
                </div>
            </div>
            <div v-if="saison.mode==0"> 
                <div class="title is-6">
                    Le joueur ayant le plus GRAND nombre de points gagne
                </div>
                <div style="float:right">
                    <s-button theme="is-small is-warning" icon="undo" label="Changer de mode" @onclick="saison.mode=null"/>
                </div>
                <label class="title is-5">
                <s-l id="title_bareme">Barême des points</s-l>                            
                </label>
                <br/><br/>
                <div style="text-align:center">
                    <div style="padding-bottom: 10px" class="formPoints"> 
                        <div class="labelBareme">Chaque partie gagnée : </div>
                        <input type="number" style="width:80px" 
                            class="input is-rounded  is-success"
                            v-model="saison.pointWin"/> &nbsp; points
                    </div>
                    <div style="padding-bottom: 10px"  class="formPoints"> 
                        <div class="labelBareme">Chaque partie perdue :  </div><input type="number" 
                            style="width:80px" class="input is-rounded   is-danger"
                            v-model="saison.pointLose"/> &nbsp; points
                    </div>
                     <div style="padding-bottom: 10px"  class="formPoints"> 
                        <div class="labelBareme">En cas d'égalité :  </div><input type="number" 
                            style="width:80px" class="input is-rounded   is-danger"
                            v-model="saison.pointEgality"/> &nbsp; points
                    </div>
                    <div style="padding-bottom: 10px"  class="formPoints"> 
                        <div class="labelBareme">Absent du concours : </div><input type="number" 
                            style="width:80px" class="input is-rounded is-dark"
                                v-model="saison.pointAbs"/> &nbsp; points
                    </div>
                    <div style="padding-bottom: 10px"  class="formPoints"> 
                        <div class="labelBareme">Présent au concours : </div><input type="number" 
                            style="width:80px" class="input is-rounded is-info"
                                v-model="saison.pointPres"/> &nbsp; points
                    </div>
                </div>
            </div>
            <div v-if="saison.mode==1" class="mode1"> 
                <div style="float:right">
                    <s-button theme="is-small is-warning" icon="undo" label="Changer de mode" @onclick="saison.mode=null"/>
                </div><div class="title is-6">
                    <s-l id="saisonClassement_titleByClassement">Le joueur ayant le plus PETIT nombre de points gagne</s-l>
                </div>
                 <br/>
                 <div class="">
                    <s-l id="saisonClassement_explainByClassement">Qu'il gagne ou qu'il perd, son classement détermine ses points. Par exemple, si un joueur termine 5ème, il obtient 5 points.</s-l>
                </div>
                <hr/>
               <div class="">
                    Si il est absent, il prend : &nbsp;&nbsp;
                    <input type="text" style="width: 100px" class="input is-rounded is-dark" v-model="saison.pointAbs"/>
                     &nbsp;&nbsp;points
                     
                </div>
            </div>
             <div v-if="saison.mode!=null" class="tolerance">
                <s-l id="saisonClassement_explainbest">Vous pouvez effectuer le classement sur un certains nombre de concours. Le système prendra les concours où le joueur a obtenu les meilleurs résultats <br/></s-l>
                <span style="font-size:18px">Nombre de concours à prendre en compte :</span>&nbsp;&nbsp;
                <input style="width:100px" type="text" class="input is-rounded is-warning" v-model="saison.tolerance"/>
                &nbsp;<s-button icon="times" label="" @onclick="saison.tolerance=''" theme="is-warning"/>
                </br>
                
             </div>
        </div>
    </s-modal>
    
</template>
<style scoped>
    .tolerance {
         color: black;
        font-size: 13px;
        font-weight: bolder;
        background-color: antiquewhite;
        border-radius: 10px;
        padding: 5px;
        text-align:center;
        margin-top: 5px;
    }
    .buttonMode {
        padding: 5px;
        font-size: 16px;
        border: thin solid black;
        margin: 5px;
       
    }
    .buttonMode:hover {
        background-color: antiquewhite;
         cursor: pointer;
    }
    .formPoints {
        color: black;
        font-size: 15px;
        font-weight: bolder;
    }
    .mode1 {
         color: black;
        font-size: 15px;
        font-weight: bolder;
    }
    .labelBareme {
        display: inline-flex;
        margin: 5px;
        width: 170px;
        
    }
</style>
<script>
import season_fct from "@/firebase/season"
export default {
    props: ["club", "saison", "open"],
    data() {
        return {
           
        }
    },
    computed: {
         yearToDay: {
            get() {
                var date = new Date();
                return date.getFullYear();
            }
        },
        saved: {
            get() {
                if (this.saison!=null)
                    return (this.saison.mode!=null)
                else
                    return false;
            }
        }
    },
    methods: {
        save() {
            season_fct.object.set(this.club, this.saison, saisonTempo=>{
                this.$emit("close");
            });
        },
        setMode(mode) {
            if (mode==0) 
                this.saison.pointAbs = -10;
            else
                this.saison.pointAbs = 99;
            this.saison.mode = mode;
        }
    }
}
</script>
                    